import styled, { css } from 'styled-components';
import { switchProp } from 'styled-tools';
import { bombasGreen, white } from 'Styles/colors';
import IconOriginal from '../Icon';

export const ConfirmationIcon = styled.div`
  position: relative;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;

  ${switchProp('$size', {
    small: css`
      width: 25px;
    `,
    large: css`
      width: 79px;
      height: 57px;
    `
  })}
`;

export const Hexagon = styled.span`
  font-family: var(--glyph-font), sans-serif;
  line-height: 24px;
  color: ${bombasGreen};
  font-variant: normal;
  position: absolute;

  ${switchProp('$size', {
    small: css`
      font-size: 44px;
      top: 1px;
    `,
    large: css`
      font-size: 112px;
      top: 15px;
      left: 2px;
    `
  })}

  &:before {
    content: 'C';
  }
`;

export const Icon = styled(IconOriginal)`
  color: ${white};

  ${switchProp('$size', {
    small: css`
      top: 8px;
    `
  })}
`;
